module.exports = __webpack_public_path__ + "img/main2.10ce5cc2.webp";